import { isLanguageId, type LanguageId } from '@/features/language/types'
import { isThemeId, type ThemeId } from '@/features/theme/types'

/**
 * 계정에 남은 화면 설정.
 *
 * 두 값 모두 null일 수 있다. 아직 고른 적이 없다는 뜻이고 서버가 기본값을 대신 채우지 않는다.
 * 값이 없을 때 화면이 무엇으로 그리는지는 화면의 규칙이다.
 */
export interface Preferences {
  themeId: ThemeId | null
  languageId: LanguageId | null
}

export interface SessionSnapshot {
  preferences: Preferences
}

/**
 * 서버가 준 값을 화면이 아는 값으로만 좁힌다.
 *
 * 목록에 없는 값은 없는 것으로 다룬다. 서버가 우리보다 앞서 새 값을 열었을 때 화면이 모르는
 * 이름으로 테마를 그리려다 아무것도 그리지 못하는 것보다, 고른 적 없는 상태로 두고 기본값으로
 * 그리는 편이 낫다.
 */
export function readPreferences(value: unknown): Preferences {
  const source = (value as { preferences?: Record<string, unknown> } | null)?.preferences
  return {
    themeId: isThemeId(source?.themeId) ? source.themeId : null,
    languageId: isLanguageId(source?.languageId) ? source.languageId : null,
  }
}
